import * as services from '@api';

/**
 * 变更历史记录
 * @param rootStore
 * @param options {
 *  // 选填字段
 *  dataSourceAlias: string， 默认值：cardStore.dataSource
 *  cardStoreKey: string， 默认值：cardStore
 * }
 * @hooks {
 *  // 专有钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export async function changeHistory(rootStore: any, options: any = {}) {
  const { utils = {}, pageStore = {} } = rootStore
  const { params = {}, query = {} } = pageStore

  try {
    // 发送请求
    pageStore?.startLoading?.()
    const res = await services.changeHistory({
      params: {
        struct: 2,
        serviceCode: query?.serviceCode || params?.serviceCode || '',
        busiObj: options.busiObj || query?.busiObj || params?.busiObj || '',
        busiObjId: options.billId || query?.billId || params?.billId || '',
        busiObjTypeCode: options.busiObj || query?.busiObj || params?.busiObj || ''
      }
    })
    // cardStore.setValue(res.data, { merge: true });
    utils.message.success(lang.templateByUuid('UID:P_CORE-YNF-FE_18A243FC05A8000E', '变更成功'))
    return res
  } catch (err:any) {
    utils.message.danger(err?.message)
    return Promise.reject(err)
  } finally {
    pageStore?.endLoading?.()
  }
}
